/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    state: PropTypes.oneOf([
        'pending',
        'info',
        'success',
        'error',
    ]).isRequired,
};

const defaultProps = {
    ...commonDefaultProps,
    state: 'pending',
};

const NotificationItem = (props) => {
    const classNames = [
        'c-notification__item',
        props.state === 'pending' ? 'c-notification__item--loading' : '',
        props.state === 'info' ? 'c-notification__item--info' : '',
        props.state === 'success' ? 'c-notification__item--success' : '',
        props.state === 'error' ? 'c-notification__item--error' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

NotificationItem.propTypes = propTypes;

NotificationItem.defaultProps = defaultProps;

export default NotificationItem;
